'use client';

import React from 'react';
import styles from './public-layout.module.css';

interface PublicLayoutProps {
  children: React.ReactNode;
  onLoginClick?: () => void;
}

export default function PublicLayout({ children, onLoginClick }: PublicLayoutProps) {
  return (
    <div className={styles.publicContainer}>
      {/* Header */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          {/* Logo */}
          <a href="#/" className={styles.logoLink}>
            <h1 className={styles.logo}>🌊 FLOW</h1>
          </a>

          {/* Navigation */}
          <nav className={styles.navLinks}>
            <a href="#/ideas" className={styles.navLink}>
              Ideas
            </a>
            <a href="#/roadmap" className={styles.navLink}>
              Roadmap
            </a>
          </nav>

          {/* Login Button */}
          <button onClick={onLoginClick} className={styles.loginButton}>
            Sign In
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className={styles.mainContent}>
        {children}
      </main>

      {/* Footer */}
      <footer className={styles.footer}>
        <p>&copy; 2026 Portfolio Management. All ideas welcome.</p>
      </footer>
    </div>
  );
}
